'use client'

/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */
import { styled, Flex, $fontWeightBolder, $fontSize, $fontWeightNormal } from '@acko-tech/building-blocks.ui.common'
import { H1 } from '@acko-tech/building-blocks.ui.typography'

export const TopicsContainer = styled(Flex)`
  flex-direction: column;
  box-sizing: border-box;
  margin-top: 10px;

  @media screen and (min-width: 1141px) {
    max-width: 1170px;
    margin-left: auto;
    margin-right: auto;
  }
`

export const TopicsWrapper = styled.div`
  padding-left: 20px;
  padding-right: 20px;

  @media screen and (min-width: 1141px) {
    padding: 0;
  }
`

export const Title = styled(H1)`
  font-weight: ${$fontWeightBolder};
  font-size: ${$fontSize.medium};
  line-height: ${$fontSize.large};
  letter-spacing: 0.01em;
  margin-bottom: 16px;
  margin-top: 8px;

  color: #414a53;
`

export const TopicsList = styled(Flex)`
  flex-direction: column;
  margin-bottom: 20px;
  /* & > div:last-child {
        margin-bottom: 45px;
    } */

  @media screen and (min-width: 426px) {
    flex-direction: row;
    flex-wrap: wrap;

    /* & > div:last-child {
            margin-bottom: 60px;
        } */

    & > div:nth-child(odd) {
      margin-right: 50px;
    }

    & > div:nth-child(even) {
      margin-left: 50px;
    }
  }
`

export const TopicItem = styled(Flex)`
  align-items: center;
  width: 100%;
  font-weight: ${$fontWeightNormal};
  font-size: ${$fontSize.xs};
  color: #434f5a;
  padding-top: 18px;
  padding-bottom: 12px;
  box-sizing: border-box;
  border-bottom: 1px solid #e4eaf1;

  & > picture:first-child {
    margin-right: 18px;
  }

  & > img:last-child {
    margin-left: auto;
  }
  a {
    text-decoration: none;
    color: inherit;
  }

  @media screen and (min-width: 426px) {
    width: calc(50% - 50px);
    font-size: ${$fontSize.small};
    padding-top: 30px;
  }
`
